var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "63px",
    viewBox: "0 0 73 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 64.0024548,
    height: 39.0164169,
    rx: 2.39261513
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "012--A",
    transform: "translate(-171.000000, -133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ilust-credit-card",
    transform: "translate(170.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DEF9FD",
    cx: 37.5,
    cy: 31.5,
    r: 31.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(37.500000, 32.000000) rotate(-20.000000) translate(-37.500000, -32.000000) translate(5.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Credit-card",
    transform: "translate(0.268615, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#7FDCF4",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1CC1EB",
    mask: "url(#mask-2)",
    x: 0,
    y: 22.8095976,
    width: 64.0024548,
    height: 7.80328338
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.9353824,16.2068193 L20.9353824,18.6078296 L5.98153783,18.6078296 L5.98153783,16.2068193 L20.9353824,16.2068193 Z M26.9169202,16.2068193 L26.9169202,18.6078296 L23.9261513,18.6078296 L23.9261513,16.2068193 L26.9169202,16.2068193 Z",
    id: "Combined-Shape",
    fill: "#F9FAFC"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicon);
export default __webpack_public_path__ + "static/media/card.icon.e4589e50d8bd6d60d41c050ae0dbeeeb.svg";
export { ForwardRef as ReactComponent };